// Framework
import MenuListComponent from './MenuListComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getSortedMenu } from 'actions/auth/login';
import { action as toggleMenu } from 'redux-burger-menu';

// Connect the STATE to the props fed into the component.
export const mapStateToProps = (state) => ({
  menu: getSortedMenu(state)
});

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      toggleMenu
    },
    dispatch
  );
};

// Create higher-order component which feeds in specified props.
const MenuListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuListComponent);

export default MenuListContainer;



// WEBPACK FOOTER //
// ./src/components/common/SideMenu/MenuList/MenuListContainer.js